import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {Checkbox} from "primereact/checkbox";

import Btn from "../../ui/Btn";
import clubStore from "../../storage/ClubStore";
import appStore from "../../storage/AppStore";
import systemStore from "../../storage/SystemStore";
import "../../common/game.css";

const GameParticipantsEditor = ({gameId, gameTeamId, title, companyId, readOnly = false}) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!gameId || !gameTeamId) return;
    clubStore.tournament.getGameParticipants(gameId, gameTeamId, companyId).then((ret) => {
      setItems(ret?.participants || []);
    });
  }, [gameId, gameTeamId]);

  const toggleSelected = (idx, checked) => {
    const copy = [...items];
    copy[idx] = {...copy[idx], selected: checked};
    setItems(copy);
  };

  const save = () => {
    const participants = items
      .filter(x => x.selected)
      .map(x => ({
        company_user_id: x.id,
        status: x.status || "invited",
        starter: !!x.starter,
        captain: !!x.captain,
        is_billable: x.is_billable !== false,
        minutes_played: x.minutes_played,
        position: x.position,
        notes: x.notes,
      }));

    clubStore.tournament.saveGameParticipants(gameId, gameTeamId, participants, companyId).then((ret) => {
      setItems(ret?.participants || []);
      systemStore.setSuccess(appStore.tr.successfully_saved);
    });
  };

  const selectedCount = items.filter(x => x.selected).length;

  return (
    <div className="competition-form__section">
      <div className="flex flex-wrap align-items-center justify-content-between gap-3">
        <div className="competition-form__section-heading">
          <span className="competition-form__section-icon">
            <i className="pi pi-users" aria-hidden="true"/>
          </span>
          <h4>{title}</h4>
        </div>
        <div className="flex flex-wrap align-items-center gap-2">
          <span className="badge badge-success">
            <i className="pi pi-check-circle" aria-hidden="true"/>
            {selectedCount}
          </span>
          <span className="badge badge-tournament">
            <i className="pi pi-users" aria-hidden="true"/>
            {items.length}
          </span>
        </div>
      </div>

      {items.length > 0 ? (
        <div className="grid m-0">
          {items.map((m, idx) => (
            <div key={m.id} className="col-12 md:col-6 p-2">
              <div className="competition-detail-item flex align-items-center gap-3 h-full">
                <Checkbox inputId={`game-participant-${gameId}-${gameTeamId}-${m.id}`}
                  checked={!!m.selected} disabled={readOnly}
                  onChange={(e) => toggleSelected(idx, e.checked)}/>
                <label htmlFor={`game-participant-${gameId}-${gameTeamId}-${m.id}`}
                  className="flex-1 min-w-0 cursor-pointer">
                  <span className="block font-semibold line-height-3">{m.title}</span>
                  <span className="block text-sm text-color-secondary mt-1">
                    {m.year_born || "—"} {m.forma_number ? ` • #${m.forma_number}` : ""}
                  </span>
                </label>
                {m.selected && (
                  <span className="badge badge-success flex-shrink-0">
                    <i className="pi pi-check" aria-hidden="true"/>
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="surface-ground border-round-lg p-4 text-center text-color-secondary">
          <i className="pi pi-users text-xl block mb-2" aria-hidden="true"/>
          {appStore.tr.not_found}
        </div>
      )}

      {!readOnly && (
        <div className="flex justify-content-end pt-3 border-top-1 surface-border">
          <Btn icon="pi pi-save" label={appStore.tr.save} severity="success"
            className="w-full md:w-auto" onClick={save}/>
        </div>
      )}
    </div>
  );
};

export default observer(GameParticipantsEditor);
